import React from 'react';

import '../../../css/thrivecheckbox.scss';



const ThriveCheckBox = ({id, value, change, name, size = {height: '10px', width: '12px'}, newStyleTick = false}) => {
    return (
        <>
            <svg className="checkbox-symbol" aria-hidden="true">
                <symbol id="check" viewBox="0 0 18 6">
                    <polyline
                        points={newStyleTick ? "2 5 4.5 8 11 3" : "2 6 4.5 8 9.5 1"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    ></polyline>
                </symbol>
        </svg>

        <div className="checkbox-container" >
        <input className="checkbox-input" id={id} type="checkbox" checked={value} onChange={change} aria-label={`${name} enabled`} aria-checked={value}/>
            <label className="checkbox" htmlFor={id} aria-hidden="true">
                <span>
                <svg width={ size.width } height={ size.height }>
                    <use xlinkHref="#check"></use>
                </svg>
                </span>
            </label>
        </div>
    </>  
    )
}

export default ThriveCheckBox